import { render, staticRenderFns } from "./OtherTile.vue?vue&type=template&id=7e844a6e&"
import script from "./OtherTile.vue?vue&type=script&lang=js&"
export * from "./OtherTile.vue?vue&type=script&lang=js&"
import style0 from "./OtherTile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OtherTile.vue"
export default component.exports